export function angleBetweenPoints(origin, target)	{
	origin.x = origin.x - target.x;
	origin.y = origin.y - target.y;
	var angle = Math.atan2(origin.y, origin.x) * 57.29577951308232;
	// angle -= 90;
	if(isNaN(angle)){
		throw new Error('Expecting a number result from angleBetweenPoints.');
	}
	return (angle);
}

export function pointAlongLine(dist, x1, y1, x2, y2) {

	var dx = x1 - x2;
	var dy = y1 - y2;
	var x3 = x1 - (dx * dist);
	var y3 = y1 - (dy * dist);
	if(isNaN(x3) || isNaN(y3)){
		throw new Error('Expecting a matrix of numbers result from pointAlongLine.');
	}
	return {x: x3, y: y3};
}

export function getDistance( x1, y1, x2, y2 ) {
	var xs = x2 - x1,
		ys = y2 - y1;
	xs *= xs;
	ys *= ys;
	var result = Math.sqrt( xs + ys );
	if(isNaN(result)){
		throw new Error('Expecting a number result from getDistance.');
	}
	return result
};

export function getTimelineDuration(tl) {
	tl.calcDuration();
	let stones = [0];
	tl.data.forEach((tw, i) => {
		const off = tw.offset;
		const arr = off ? off.toString().split('=') : [];
		const startTime = off === null ? stones[i] :
			!isNaN(off) ? off :
			stones[i] + (arr[0] === '-' ? -1 : 1) * arr[1];
		stones[i+1] = startTime + tw.duration;
	})
	return Math.max(...stones);
}
export function isValidHand(hand) {
	return hand.match && hand.match.length > 2;
}